export const fieldToLabel = {
  loan_amount: 'Loan Amount',
  estimated_property_value: 'Estimated Property Value',
  purchase_price: 'Purchase Price',
};

export const fieldToBody = {
  loan_amount: 'loanAmount',
  estimated_property_value: 'estimatedPropertyValue',
  purchase_price: 'purchasePrice',
  loan_number: 'loanId',
};
